var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTranslationRefreshDisableIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.22 15.117c-1.018 3.194-3.934 5.5-7.372 5.5-4.284 0-7.757-3.582-7.757-8s3.473-8 7.757-8c2.872 0 5.379 1.609 6.72 4m-2.356 1h3.879v-4",
    stroke: "#87888D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTranslationRefreshDisableIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TranslationRefreshDisableIcon.49635631.svg";
export { ForwardRef as ReactComponent };